<template>
    <div></div>
    <!-- <section
        role="alert"
        class="momo__info"
    >
        <p>
            {{ $t("mm.elevy.notice") }}
        </p>
    </section> -->
</template>
<script>
export default {
    name: "MomoGHSLevyNotice",
};
</script>
<style lang="scss" scoped>
    .momo__info {
        width: 100%;
        background: #FFFDFB;
        border: 1px solid rgba(108, 108, 108, 0.15);
        box-sizing: border-box;
        border-radius: 4px;
        margin-bottom: 1rem;

        padding: 14px;
        color: $black-3;

        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
    }
</style>